import { render, staticRenderFns } from "./OrderMovements.vue?vue&type=template&id=3f500fe1&scoped=true"
import script from "./OrderMovements.vue?vue&type=script&lang=js"
export * from "./OrderMovements.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f500fe1",
  null
  
)

export default component.exports